module.exports = __webpack_public_path__ + "media/images/close-light-8a49f0132f4ee0ae765a222ef36cd366.svg";